(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-editorial"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hero-motion]').forEach(function(player){
  if(player.dataset.initialized)return;player.dataset.initialized='true';
  const video=player.querySelector('video'),button=player.querySelector('[data-hero-toggle]');
  if(!video||!button)return;button.hidden=false;video.muted=true;
  function update(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-label',button.textContent);}
  video.addEventListener('loadeddata',function(){player.classList.add('has-frame');});
  video.addEventListener('playing',function(){player.classList.add('has-frame');update();});video.addEventListener('pause',update);
  button.addEventListener('click',function(){if(video.paused)video.play().catch(update);else video.pause();});
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(!motion.matches)video.play().catch(update);
  motion.addEventListener('change',function(e){if(e.matches)video.pause();});
  const observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting)video.pause();else if(!motion.matches)video.play().catch(update);});},{threshold:.15});observer.observe(player);
  document.addEventListener('visibilitychange',function(){if(document.hidden)video.pause();});update();
});

  } catch(e) { console.error(e); }
})();
})();
